import restSetGuestPaymentMethod from './restSetGuestPaymentMethod';

export default restSetGuestPaymentMethod;
